import Vue from 'vue';

Vue.component('stock-fifo-index', () =>
    import(/* webpackChunkName: 'stock-fifo-index' */ './stock-fifo-index.vue'),
);
